// main JS

// ===== Shine effect cho .MS__hover-shine =====
// Vẽ một dải sáng quét ngang qua element, mask theo background-image (sprite)
// để dải sáng chỉ hiện trong vùng pixel của button.
// Pause khi element off-screen (IntersectionObserver) hoặc tab ẩn (visibilitychange)
// để không đốt GPU khi user không thấy.
(function () {
  var instances = [];
  var pageVisible = !document.hidden;

  function initShine() {
    $('.MS__hover-shine').each(function () {
      var el = this;
      var $el = $(this);
      var style = window.getComputedStyle(el);

      var bgImg = style.backgroundImage;
      var spriteUrl = null;
      if (bgImg && bgImg !== 'none') {
        var m = bgImg.match(/url\((['"]?)(.+?)\1\)/);
        spriteUrl = m ? m[2] : null;
      }
      if (!spriteUrl) {
        console.warn('initShine: missing background-image', el);
        return;
      }

      var bgPosParts = (style.backgroundPosition || '0px 0px').split(/\s+/);
      if (bgPosParts.length === 1) bgPosParts[1] = '0px';
      var bgX = parseInt(bgPosParts[0], 10) || 0;
      var bgY = parseInt(bgPosParts[1], 10) || 0;

      var width = 0, height = 0;
      var canvas = document.createElement('canvas');
      canvas.style.position = 'absolute';
      canvas.style.top = 0;
      canvas.style.left = 0;
      canvas.style.pointerEvents = 'none';
      canvas.style.zIndex = 1;

      if (style.position === '' || style.position === 'static') {
        $el.css('position', 'relative');
      }
      $el.append(canvas);

      var ctx = canvas.getContext && canvas.getContext('2d');
      if (!ctx) {
        $el.find('canvas').last().remove();
        return;
      }
      var image = new Image();
      var maskReady = false;
      var maskFailed = false;

      var lightX = -200;
      var SPEED = 900;
      var LOOP_DELAY = 2000;
      var animId = null;
      var loopTimeoutId = null;
      var lastTs = 0;
      var inView = false;

      var inst = {
        get active() { return inView && pageVisible; },
        start: startShine,
        stop: stopShine,
      };
      instances.push(inst);

      function refreshDimensions() {
        var w = el.offsetWidth || el.clientWidth;
        var h = el.offsetHeight || el.clientHeight;
        if ((!w || !h) && el.getBoundingClientRect) {
          var r = el.getBoundingClientRect();
          w = r.width; h = r.height;
        }
        if (!w || !h || (width === w && height === h)) return;
        width = w; height = h;
        canvas.width = width; canvas.height = height;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        ctx.clearRect(0, 0, width, height);
      }
      refreshDimensions();

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () { refreshDimensions(); }).observe(el);
      }

      image.onload = function () { maskReady = true; };
      image.onerror = function () {
        maskFailed = true;
        console.warn('initShine: failed to load sprite', spriteUrl);
        stopShine();
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      };
      image.src = spriteUrl;
      if (image.complete && image.naturalWidth > 0) maskReady = true;

      function drawShine(ts) {
        if (!inst.active || maskFailed) { animId = null; return; }
        if (!maskReady) { animId = requestAnimationFrame(drawShine); return; }
        if (!width || !height) { animId = requestAnimationFrame(drawShine); return; }
        if (!lastTs) lastTs = ts || performance.now();
        var now = ts || performance.now();
        var dt = Math.min((now - lastTs) / 1000, 0.1);
        lastTs = now;
        ctx.clearRect(0, 0, width, height);

        var bandWidth = Math.max(width * 0.45, 140);
        var gradient = ctx.createLinearGradient(
          lightX - bandWidth, -height,
          lightX + bandWidth, height * 2
        );
        gradient.addColorStop(0, 'rgba(255,255,255, 0)');
        gradient.addColorStop(0.4, 'rgba(255,255,255, 0.4)');
        gradient.addColorStop(0.5, 'rgba(255,255,255, 0.8)');
        gradient.addColorStop(0.6, 'rgba(255,255,255, 0.4)');
        gradient.addColorStop(1, 'rgba(255,255,255, 0)');

        ctx.globalCompositeOperation = 'source-over';
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, width, height);

        if (maskReady) {
          ctx.globalCompositeOperation = 'destination-in';
          ctx.drawImage(image, -bgX, -bgY, width, height, 0, 0, width, height);
        }
        ctx.globalCompositeOperation = 'source-over';

        lightX += SPEED * dt;
        var endMargin = bandWidth + (3 * height * height) / Math.max(bandWidth, 1);
        if (lightX > width + endMargin) {
          if (animId) { cancelAnimationFrame(animId); animId = null; }
          ctx.clearRect(0, 0, width, height);
          loopTimeoutId = setTimeout(function () {
            loopTimeoutId = null;
            if (inst.active) startShine();
          }, LOOP_DELAY);
          return;
        }
        animId = requestAnimationFrame(drawShine);
      }

      function startShine() {
        if (animId || loopTimeoutId || !inst.active) return;
        refreshDimensions();
        lightX = -Math.max(width, 200);
        lastTs = 0;
        animId = requestAnimationFrame(drawShine);
      }

      function stopShine() {
        if (animId) { cancelAnimationFrame(animId); animId = null; }
        if (loopTimeoutId) { clearTimeout(loopTimeoutId); loopTimeoutId = null; }
        if (width && height) ctx.clearRect(0, 0, width, height);
      }

      if (typeof IntersectionObserver !== 'undefined') {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting;
            if (inst.active) startShine();
            else stopShine();
          });
        }, { threshold: 0 }).observe(el);
      } else {
        inView = true;
        startShine();
      }
    });
  }

  document.addEventListener('visibilitychange', function () {
    pageVisible = !document.hidden;
    instances.forEach(function (inst) {
      if (inst.active) inst.start();
      else inst.stop();
    });
  });

  window.addEventListener('load', initShine);
})();
